import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import ICONS from "../../../../assets/Icons";

import { getUsers } from "../../../../redux/features/Settings/Management/Users";
import accountNameStandardised from "../../../../utils/accountNamestandardised";
import globalText from "../../../../utils/globalText";
import TickerAnimation from "../../../_utils/TickerAnimation";
import Loader from "../../../Loader/Index";
import "./index.css";

const TextAuthMatrixSelectUser = ({
  pageType,
  activeStep,
  setSelectedUser,
  selectedUser,
  selectedPreviousUsersId,
  setSelectedPreviousUsersId,
  selectedPreviousUsers,
  setSelectedPreviousUsers,
}) => {
  //variables -------
  const dispatch = useDispatch();

  //states -------
  const [usersLoading, setUsersLoading] = useState(false);
  const [formattedUserData, setFormatedUserData] = useState({});

  //functions -------
  const fetchUsers = async () => {
    setUsersLoading(true);

    try {
      //fetching all data of users
      const firstPage = await dispatch(
        getUsers({ page_no: 1, page_size: 100 }),
      );

      if (firstPage?.payload?.status === true) {
        const totalCount = firstPage.payload.total_count;
        const totalPages = Math.ceil(totalCount / 100);

        let allEmployees = [...firstPage.payload.employees];

        if (totalPages > 1) {
          for (let i = 2; i <= totalPages; i++) {
            const res = await dispatch(
              getUsers({ page_no: i, page_size: 100 }),
            );

            if (res?.payload?.status === true) {
              allEmployees = [...allEmployees, ...res.payload.employees];
            } else {
              console.error(`Failed to fetch page ${i}`);
            }
          }
        }

        //grouping users as per grades
        let groupedData = {};

        for (let i = 0; i < allEmployees.length; i++) {
          if (
            selectedUser?.[0]?.id &&
            selectedUser?.[0]?.id === allEmployees[i]?.id &&
            pageType === "previousUsers"
          ) {
            continue;
          } else {
            const employee = allEmployees[i];
            const grade = employee?.grade?.trim();

            if (grade) {
              if (!groupedData[grade]) {
                groupedData[grade] = [employee];
              } else {
                groupedData[grade].push(employee);
              }
            }
          }
        }

        setFormatedUserData(groupedData);
      }
    } catch (error) {
      console.error("Error fetching users:", error);
    }
    setUsersLoading(false);
  };

  //useEffects -------
  useEffect(() => {
    fetchUsers();
  }, [activeStep]);

  useEffect(() => {
    if (pageType === "previousUsers") {
      if (selectedPreviousUsersId?.includes(selectedUser?.[0]?.id)) {
        setSelectedPreviousUsersId(
          selectedPreviousUsersId.filter(
            (item) => item !== selectedUser?.[0]?.id,
          ),
        );
        setSelectedPreviousUsers(
          selectedPreviousUsers.filter(
            (item) => item?.id !== selectedUser?.[0]?.id,
          ),
        );
      }
    }
  }, [selectedUser, selectedPreviousUsers]);

  return (
    <>
      <div className="test-auth-sel-user-container mb-margin-md md:mb-margin-base px-padding-md Qlg:px-padding-base">
        <div className="test-auth-sel-user-main-div">
          <div className="test-auth-sel-user-top-div">
            <span className="text-base font-semibold text-text-primary">
              {pageType === "users"
                ? "Select User"
                : pageType === "previousUsers"
                  ? globalText?.PREVIOUS_APPROVERS_OPTIONAL
                  : undefined}
            </span>
            <span className="text-xs font-normal text-text-secondary">
              {pageType === "users"
                ? "Select user who is approving the transaction."
                : pageType === "previousUsers"
                  ? "Select previous approver/s who have already approved the transaction."
                  : undefined}
            </span>
          </div>
          <div className="test-auth-sel-user-bottom-div">
            {usersLoading ? (
              <div className="flex justify-center items-center py-4">
                <Loader />
              </div>
            ) : Object.entries(formattedUserData)?.length > 0 ? (
              Object.entries(formattedUserData).map(([grade, arr]) => (
                <div
                  key={grade}
                  className="test-auth-sel-user-grade-main-div"
                >
                  <div className="test-auth-sel-user-grade-tilte text-text-primary">
                    {grade}
                  </div>

                  <div className="test-auth-sel-user-grade-cards-div">
                    {arr?.map((val) => {
                      const fullname =
                        [val?.first_name, val?.last_name]
                          .filter(Boolean)
                          .join(" ") || "";

                      return (
                        <div
                          key={val?.id}
                          className="bg-primary-nav rounded-border-radius-md cursor-pointer flex global-hover-white group "
                          onClick={() => {
                            if (pageType === "previousUsers") {
                              if (
                                selectedPreviousUsersId?.includes(val?.id) ||
                                selectedUser?.[0]?.id === val?.id
                              ) {
                                setSelectedPreviousUsersId(
                                  selectedPreviousUsersId.filter(
                                    (item) => item !== val?.id,
                                  ),
                                );
                                setSelectedPreviousUsers(
                                  selectedPreviousUsers.filter(
                                    (item) => item?.id !== val?.id,
                                  ),
                                );
                              } else {
                                setSelectedPreviousUsersId([
                                  ...selectedPreviousUsersId,
                                  val?.id,
                                ]);
                                setSelectedPreviousUsers([
                                  ...selectedPreviousUsers,
                                  val,
                                ]);
                              }
                            } else if (pageType === "users") {
                              if (selectedUser?.[0]?.id !== val?.id) {
                                setSelectedUser([val]);
                              }
                            }
                          }}
                        >
                          <div className="flex w-full group relative bg-primary-nav global-hover-white rounded-border-radius-md z-z-index-base transition-colors duration-animation-fast-s overflow-hidden items-center">
                            <div
                              class={`absolute bg-positive-bg group-hover:bg-positive-bg-hover z-z-index-header`}
                              style={{
                                transform:
                                  (val?.id === selectedUser?.[0]?.id &&
                                    pageType === "users") ||
                                  (selectedPreviousUsersId?.includes(val?.id) &&
                                    pageType === "previousUsers")
                                    ? "scale(1)"
                                    : "scale(0)",
                                transformOrigin: "right",
                                transition:
                                  (val?.id === selectedUser?.[0]?.id &&
                                    pageType === "users") ||
                                  (selectedPreviousUsersId?.includes(val?.id) &&
                                    pageType === "previousUsers")
                                    ? "transform var(--animation-fast-xs) ease-in"
                                    : "transform var(--animation-fast-s) ease-in",
                                height: "var(--height-full)",
                                width:
                                  "calc(var(--width-full) - var(--icon-lg))",
                                borderRadius:
                                  "var(--border-radius-sm) var(--border-none) var(--border-none) var(--border-radius-sm)",
                              }}
                            ></div>
                            <div
                              class={`absolute bg-positive-bg group-hover:bg-positive-bg-hover z-z-index-header`}
                              style={{
                                transform:
                                  (val?.id === selectedUser?.[0]?.id &&
                                    pageType === "users") ||
                                  (selectedPreviousUsersId?.includes(val?.id) &&
                                    pageType === "previousUsers")
                                    ? "scale(1)"
                                    : "scale(0)",
                                transformOrigin: "left",
                                transition:
                                  (val?.id === selectedUser?.[0]?.id &&
                                    pageType === "users") ||
                                  (selectedPreviousUsersId?.includes(val?.id) &&
                                    pageType === "previousUsers")
                                    ? "transform var(--animation-fast-xs) ease-in"
                                    : "transform var(--animation-fast-s) ease-in",
                                left: "calc(var(--left-full) - var(--icon-lg))",
                                height: "var(--height-full)",
                                width: "var(--icon-lg)",
                                borderRadius:
                                  "var(--border-none) var(--border-radius-sm) var(--border-radius-sm) var(--border-none)",
                              }}
                            ></div>

                            <div className="flex flex-col justify-center pl-padding-md pr-padding-sm py-padding-sm flex-1 min-w-0 relative z-z-index-header gap-gap-xs">
                              <p className="text-text-primary text-font-sm font-semibold">
                                <TickerAnimation
                                  text={accountNameStandardised(fullname)}
                                />
                              </p>

                              <p className="text-text-secondary text-font-xs">
                                <TickerAnimation text={val?.entity_id} />
                              </p>
                            </div>

                            <div className="pr-padding-md relative z-z-index-header">
                              <img
                                src={
                                  pageType === "users"
                                    ? val?.id === selectedUser?.[0]?.id
                                      ? ICONS?.RADIO_BUTTON_SELECTED
                                      : ICONS?.RADIO_BUTTON_NOT_SELECTED
                                    : selectedPreviousUsersId?.includes(val?.id)
                                      ? ICONS?.SELECTED_WITH_GREEN_CIRCLE
                                      : ICONS?.NOTSELECTED_WITH_GREY_CIRCLE
                                }
                                alt="selection"
                                className="h-icon-md w-icon-md"
                              />
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              ))
            ) : (
              <div className="text-sm text-text-secondary">No users found.</div>
            )}
          </div>
        </div>
      </div>
      <div className="h-pagination-height md:hidden"></div>
    </>
  );
};

export default TextAuthMatrixSelectUser;
